import {
    SET_LISTING_STATUS,
    SET_LISTING,
    SET_MARKET_REPORT,
    SET_CURRENT_LISTING_STATUS,
    SET_FETCH_LISTING_STATUS,
    SET_FETCH_MARKET_REPORT_STATUS,
    // SET_IS_SEARCH_INIT,
    SET_TOTAL_PAGE,
    SET_PAGE_NUM,
    SET_CURRENT_LISTING_NAME,
    SET_MORE_BTN_TITLE,
    SET_MORE_BTN_STYLE,
    SET_LISTING_TITLE,
    SET_SHOW_LISTING_PRICE,
    SET_SHOW_SOLD_LISTING_PRICE,
    UPDATE_SEARCH_PARAMS
} from './constants';
export default {
    //  set up  md-search  Is it initialized 
    // [SET_IS_SEARCH_INIT](state, payload = {}) {
    //     state.isSearchInit = payload.data;
    // },
    //  set up  listingStatus  the value of 
    [SET_LISTING_STATUS](state, payload = {}) {
        state.listingStatus = [...payload.data];
    },
    //  set up  listing  the value of 
    [SET_LISTING](state, payload = {}) {
        state.listing = [...payload.data];
    },
    //  set up  marketReport  the value of 
    [SET_MARKET_REPORT](state, payload = {}) {
        state.marketReport = { ...payload.data };
    },
    //  set up  currentListingStatus  the value of 
    [SET_CURRENT_LISTING_STATUS](state, payload = {}) {
        state.currentListingStatus = payload.data;
    },
    //  set up  currentListingStatus  the value of 
    [SET_FETCH_LISTING_STATUS](state, payload = {}) {
        state.fetchListingStatus = payload.data;
    },
    [SET_CURRENT_LISTING_NAME](state, payload = {}) {
        state.currentListingStatusName = payload.data;
    },
    //  set up  fetchMarketReportStatus  the value of 
    [SET_FETCH_MARKET_REPORT_STATUS](state, payload = {}) {
        state.fetchMarketReportStatus = payload.data;
    },
    //  Set the total number of pages for pagination 
    [SET_TOTAL_PAGE](state, payload = {}) {
        state.totalPage = payload.data;
    },
    //  set current page 
    [SET_PAGE_NUM](state, payload = {}) {
        state.pageNum = payload.data;
    },
    //  set up  more button
    [SET_MORE_BTN_TITLE](state, payload = {}) {
        state.moreBtnTitle = payload.data;
    },
    [SET_MORE_BTN_STYLE](state, payload = {}) {
        state.moreBtnStyle = payload.data;
    },
    [SET_LISTING_TITLE](state, payload = {}) {
        state.customListingTitle = payload.data;
    },
    //  whether to display sold listing price
    [SET_SHOW_SOLD_LISTING_PRICE](state, payload = {}) {
        state.showSoldPrice = payload.data;
    },
    //  whether to display listing price
    [SET_SHOW_LISTING_PRICE](state, payload = {}) {
        state.showListingPrice = payload.data;
    },
    [UPDATE_SEARCH_PARAMS](state, payload) {
        state.searchParams = { ...payload };
    }
};
